/** Small helpers for close-ups that show a real (pixelated) image. */
import { type Ctx, type Placement, ptext, R } from "../../engine";

/** Side marker in the image's top-left corner (patient's right on axial / AP views). */
export function sideMark(c: Ctx, p: Placement, label = "R"): void {
  R(c, "#000", p.x + 1, p.y + 1, label.length * 4 + 3, 7);
  ptext(c, label, p.x + 2, p.y + 2, "#e8e8ec");
}

/** The drawn-mode stand-in for images that only exist as photos. */
export function photoOnly(c: Ctx): void {
  R(c, "#0c0c10", 0, 0, 192, 108);
  R(c, "#2a2a34", 56, 44, 80, 20);
  ptext(c, "PHOTO", 76, 51, "#9a9aa4");
}
